import { Injectable } from '@angular/core';
import { User } from './user.model';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { VariablesService } from '../../globalService/variables.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  formData!: User;
  listUsers!: any[];
  private apiUrl = '/SegUsuarios';
  private routeApi = "SegUsuarios";
  isActiveUser: any = false;
  

  constructor(
    private generalHttp: GeneralHttpService,
    private _fb: FormBuilder,
    private variableService: VariablesService
  ) { }

  userForm: FormGroup = this._fb.group({
    IdSegUsuario: [0],
    IdSegTipoPersona: [0],
    IdTipoDocumento: [null, Validators.required],
    NumeroDocumento: ['', Validators.required],
    Nombre: ['', Validators.required],
    Apellido1: ['', Validators.required],
    Apellido2: [''],
    Telefono: [''],
    CorreoElectronico: ['', [Validators.required, Validators.email]],
    ConfirmarCorreoElectronico: ['', [this.equalsTo('CorreoElectronico'), Validators.required]],
    Cargo: [null,Validators.required],
    roles: [null, Validators.required],
    companys: [null, Validators.required],
    SegRolUsuario: null,
    SegUsuarioEmpresa: null,
    idAdmCiudad: [null, Validators.required],
    idAdmEstado:null,
    esUsuarioActivo:null,
    domainUserName:'',
    contratista: null,
  });

  private postUser(formData: User) {
    return this.generalHttp.postHttp(formData, this.routeApi);
  }
  private putUser(formData: User, id: number) {
    return this.generalHttp.putHttp(formData, id, this.routeApi);
  }

  async refreshList() {
    await this.generalHttp.getHttp<User>(this.routeApi).then((res:any[] | any) => 
    {
      this.listUsers = res
    });
  }

  getUsers(id: number) {
    return this.generalHttp.getHttpById<User>(id, this.routeApi).then((res:User | any) => {
      this.formData = res
    });
  }

  async getUserToUpdate(id: number) {
    await this.getUsers(id);
    let user = this.formData;
    this.isActiveUser = user.esUsuarioActivo;
    this.userForm.patchValue({
      IdSegUsuario: user.idSegUsuario,
      IdSegTipoPersona: user.idSegTipoPersona,
      IdTipoDocumento: user.idTipoDocumento,
      NumeroDocumento: user.numeroDocumento,
      Nombre: user.nombre,
      Apellido1: user.apellido1,
      Apellido2: user.apellido2,
      Telefono: user.telefono,
      CorreoElectronico: user.correoElectronico,
      ConfirmarCorreoElectronico: user.correoElectronico,
      Cargo: user.cargo,
      roles: this.converToArrayRol(user.segRolUsuario),
      companys: this.converToArrayCompany(user.segUsuarioEmpresa),
      SegRolUsuario: user.segRolUsuario,
      SegUsuarioEmpresa: user.segUsuarioEmpresa,
      idAdmCiudad: user.idAdmCiudad,
      esUsuarioActivo:user.esUsuarioActivo,
      domainUserName:user.domainUserName,
      contratista: user.segRolUsuarioContratista.length > 0 ? user.segRolUsuarioContratista[0].idAdmContratista : null,
    });
  }


  saveUser(companys: any, roles: any) {
    let update = false;
    let valueSubmit = Object.assign({}, this.userForm.value);
    valueSubmit = Object.assign(valueSubmit, {
      SegUsuarioEmpresa: this.toArrayCompany(valueSubmit, companys,update).filter((f: any) => f.activo == 1),
      SegRolUsuario: this.toArrayRole(valueSubmit, roles,update),
      SegRolUsuarioContratista: [],
    });
    valueSubmit.SegRolUsuarioContratista = this.toArrayContratista(valueSubmit);
    return this.postUser(valueSubmit);
  }

  updateUser(companys: any, roles: any) {
    let update = true;
    let valueSubmit = Object.assign({}, this.userForm.value);
    valueSubmit = Object.assign(valueSubmit, {
      SegUsuarioEmpresa: this.toArrayCompany(valueSubmit, companys,update).filter((f: any) => f.activo == 1),
      SegRolUsuario: this.toArrayRole(valueSubmit, roles,update),
      SegRolUsuarioContratista: [],
    });
    valueSubmit.SegRolUsuarioContratista = this.toArrayContratista(valueSubmit);
    return this.putUser(valueSubmit, valueSubmit.IdSegUsuario)
  }

  toArrayCompany(valueSubmit: any, companys: any, update: any) {
    let temp: any = [];
    if (update) {
      valueSubmit.SegUsuarioEmpresa.forEach((ele: any) => {
        temp.push({ idSegUsuarioEmpresa:ele.idSegUsuarioEmpresa,idSegUsuario:valueSubmit.IdSegUsuario, idAdmEmpresa: ele.idAdmEmpresa, activo: valueSubmit.companys.includes(ele.idAdmEmpresa.toString()) });
      });
      companys.forEach((element: any) => {
        let flag = temp.find((x: any) => x.idAdmEmpresa == element.idAdmEmpresa);
        if(typeof(flag)==='undefined'){
          temp.push({ idAdmEmpresa: element.idAdmEmpresa, activo: valueSubmit.companys.includes(element.idAdmEmpresa.toString()) });
        }
      });
    } else {
      companys.forEach((ele: any) => {
        temp.push({ idAdmEmpresa: ele.idAdmEmpresa, activo: valueSubmit.companys.includes(ele.idAdmEmpresa.toString()) });
      });
    }
    return temp;
  }


  toArrayRole(valueSubmit: any, roles: any, update: any) {
    let temp: any = [];
    if(update){
      valueSubmit.SegRolUsuario.forEach((ele: any) => {
        temp.push({ idSegRolUsuario:ele.idSegRolUsuario,idSegUsuario:valueSubmit.IdSegUsuario, idSegRol: ele.idSegRol, activo: valueSubmit.roles.includes(ele.idSegRol.toString()) });
      });
      roles.forEach((element: any) => {
        let flag = temp.find((x: any) => x.idSegRol == element.idSegRol);
        if(typeof(flag)==='undefined'){
          temp.push({ idSegRol: element.idSegRol, activo: valueSubmit.roles.includes(element.idSegRol.toString()) });
        }
      });
    }else{
      roles.forEach((ele: any) => {
        temp.push({ idSegRol: ele.idSegRol, activo: valueSubmit.roles.includes(ele.idSegRol.toString()) });
      });
    }
    return temp;
  }

  toArrayContratista(valueSubmit: any) {
    let temp: any = [];
    if(valueSubmit?.SegRolUsuario?.some((s: any) => s.idSegRol == 1013 && s.activo == true)){//Usuario PACs Contratista
      valueSubmit?.SegUsuarioEmpresa?.filter((f: any) => f.activo).forEach((ele: any) => {
        temp.push({ idSegRol: 1013, idSegUsuario: valueSubmit.IdSegUsuario, idAdmContratista: Number(valueSubmit.contratista), idAdmEmpresa: ele.idAdmEmpresa });
      });
    }
    return temp;
  }

  converToArrayRol(array: any) {
    if (typeof (array) != 'undefined') {
      let temp = array.map((e: any) => (e.activo)?e.idSegRol.toString():null);
      return temp;
    } else {
      return null;
    }
  }

  converToArrayCompany(array: any) {
    if (typeof (array) != 'undefined') {
      let temp = array.map((e: any) => (e.activo)?e.idAdmEmpresa.toString():null);
      return temp;
    } else {
      return null;
    }
  }

  getUserSearch(data: User) {
    return this.generalHttp.postHttp(data, `${this.apiUrl}/GetUserSearch`);
  }

  equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error("Diligencie la información del campo");
      }
      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null;
      }
      const field = (<FormGroup>formControl.root).get(otherField);
      if (!field) {
        throw new Error('Diligencie la información del campo');
      }
      if (field.value !== formControl.value) {
        return { equalsTo: otherField }
      }
      return null;
    };
    return validator;
  }

  getUserSatelite() {
    return this.generalHttp.getHttp(`${this.routeApi}/GetUserSatelite`);
  }

  converToArrayContratista(array: any) {
    if (typeof (array) != 'undefined') {
      let temp = array.map((e: any) => e.idPacProgramaContratista);
      return temp;
    } else {
      return null;
    }
  }
}
